import { PostProperties } from "../types";
import image from "../img/lostGemDrumcell.jpg";

const post: PostProperties = {
  id: 13,
  title: "Drumcell - Black, First Avenue, Minneapolis (20.03.2010)",
  content: " ",
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/drumcell-black-first-avenue-minneapolis-20032010",
  category: "Lost Gem",
};

export default post;
